<h-call-to-action
    class="add-to-cart-button size-{{ size }}"
    (pressed)="addToCart.emit()"
    [id]="'add-to-cart-button-in-stock-' + idSuffix"
    [type]="'submit'"
    [name]="'add-to-cart'"
    [size]="size"
    [disabled]="(addToCartButtonEnabled$ | async) === false"
    [loading]="(isLoadingAddToCart$ | async) || isloading || !formLoaded"
    [dataTestId]="'Add to cart'">
    <h-svg-icon [name]="'cart'" svgLeft></h-svg-icon>
    <span class="add-to-cart-text" i18n="@@hermes-global-translations.buy">Add to cart</span>
</h-call-to-action>
